import './DocumentDniRow.css';
import { Box, ListItem, ListItemText, Typography } from '@mui/material';
import React, { useState, useEffect, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import AppFile from '../../../../../../models/AppFile';
import ButtonFileUploader from '../../../../../../components/Buttons/ButtonFileUploader';
import { FileType } from '../../../../../../models/FileType';
import { RuleDniValidationInterface } from '../../../../../../shared/hooks/useDniValidation';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

interface DocumentDniRowProps {
  fileSize: string;
  defaultFile: AppFile | null;
  documentType: FileType;
  setFile: (file: AppFile | null) => void,
  label: string,
  buttonLabel: string,
  allowedExtensions: string[],
  dniRule: RuleDniValidationInterface | null,
  isLoading: boolean;
  flagTrafficLight: number;
  adornment: ReactNode;
  errorMessage: string | null;
}

const DocumentDniRow: React.FC<DocumentDniRowProps> = ({
  fileSize,
  defaultFile,
  documentType,
  setFile,
  label,
  buttonLabel,
  allowedExtensions,
  dniRule,
  isLoading,
  flagTrafficLight,
  adornment,
  errorMessage
}) => {
  const trafficLight = dniRule?.trafficLight
  const { t } = useTranslation();
  const [trafficLightColor, setTrafficLightColor] = useState('');

  useEffect(() => {
    if (trafficLight === 3 && !errorMessage) {
      setTrafficLightColor('#ddffdd');
    } else if (flagTrafficLight === -1 && defaultFile !== null && !errorMessage) {
      setTrafficLightColor('#ddffdd');
    } else if (trafficLight === 2 && !errorMessage) {
      setTrafficLightColor('#ffeb3b40');
    } else if (trafficLight === 1 && !errorMessage) {
      setTrafficLightColor('#ff456920');
    } else if (errorMessage && errorMessage?.length > 1) {
      setTrafficLightColor('#ff456920');
    } else {
      setTrafficLightColor('');
    }
  }, [trafficLight, dniRule, defaultFile]);

  return (
    <Box
      className="step-container-5__box-row"
      style={{ backgroundColor: errorMessage ? '#ff456920' : trafficLightColor }}
    >
      <ListItem>
        <div className="step-container-5__box-row__content">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '100%' }}>
            <div className='REQXXI-DocumentRow-ContainerLabel'>
              <ListItemText>{label} </ListItemText>
              <div className='REQXX-DocumentRow-FileInfoMobile'>
                {fileSize &&
                  <Typography color="#949494" style={{ fontSize: '10px' }}>{`(${t('maximum')} ${fileSize.toUpperCase()})`}</Typography>
                }
                <Typography color="#949494" style={{ fontSize: '10px' }}>{`(${t('allowedType')} ${allowedExtensions})`}</Typography>
              </div>
            </div>
            {dniRule?.requiredText ? <div className='REQXXI-DocumentRow-InfoLabel'>
              <Typography color="#949494" style={{ fontSize: '10px', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                {dniRule.requiredTextStatus ? <CheckIcon sx={{ color: '#006c5b87', height: '20px', width: '20px', paddingRight: '5px' }} /> : <CloseIcon sx={{ color: 'rgba(240, 0, 0)', height: '20px', width: '20px', paddingRight: '5px' }} />}
                {dniRule.requiredText}
              </Typography>
              <Typography color="#949494" style={{ fontSize: '10px', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                {dniRule.requiredTextLine2Status ? <CheckIcon sx={{ color: '#006c5b87', height: '20px', width: '20px', paddingRight: '5px' }} /> : <CloseIcon sx={{ color: 'rgba(240, 0, 0)', height: '20px', width: '20px', paddingRight: '5px' }} />}
                {dniRule.requiredTextLine2}
              </Typography>
              <Typography color="#949494" style={{ fontSize: '10px', display: 'flex', alignItems: 'center' }}>
                {dniRule.requiredTextLine3Status ? <CheckIcon sx={{ color: '#006c5b87', height: '20px', width: '20px', paddingRight: '5px' }} /> : <CloseIcon sx={{ color: 'rgba(240, 0, 0)', height: '20px', width: '20px', paddingRight: '5px' }} />}
                {dniRule.requiredTextLine3}
              </Typography>
            </div>
              : null
            }
            {errorMessage && documentType === (defaultFile?.file_type as FileType) && (
              <Typography color="#949494" style={{ fontSize: '10px', display: 'flex', alignItems: 'center' }}>
                <CloseIcon sx={{ color: 'rgba(240, 0, 0)', height: '20px', width: '20px', paddingRight: '5px' }} />
                {errorMessage}
              </Typography>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', width: '100%' }}>
            <div className='REQXX-DocumentRow-UploadContainer'>
              <ButtonFileUploader
                defaultFile={defaultFile}
                documentAllowedSize={fileSize}
                inputFileDocumentName={label}
                label={buttonLabel}
                documentType={documentType}
                onFileUploded={(fileApp) => setFile(fileApp)}
                disabled={isLoading}
              />
            </div>
          </div>
        </div>
        {adornment}
      </ListItem>
    </Box>
  );
};

export default DocumentDniRow;
